export default "__VITE_ASSET__Be9Ky78D__"